"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const paletteGreen_1 = require("../tokens/paletteGreen");
const typography_1 = require("../tokens/typography");
const material_1 = require("@mui/material");
const greenTheme = (0, material_1.createTheme)({
    breakpoints: {
        values: {
            xs: 0,
            sm: 600,
            md: 720,
            lg: 840,
            xl: 1500,
        },
        unit: 'px',
    },
    qlub: {
        palette: paletteGreen_1.paletteGreen,
        typography: typography_1.typography,
    },
    palette: {
        primary: paletteGreen_1.paletteGreen.iris,
        secondary: paletteGreen_1.paletteGreen.iris_light,
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: '100px',
                    fontSize: '1rem',
                },
                contained: {
                    background: paletteGreen_1.paletteGreen.iris.main,
                    color: paletteGreen_1.paletteGreen.onColorColors.highEmphasis,
                    border: `solid 1px transparent`,
                    boxShadow: 'none',
                    '&:hover': {
                        background: paletteGreen_1.paletteGreen.iris.main,
                        boxShadow: 'none',
                    },
                    '&:focus': {
                        background: paletteGreen_1.paletteGreen.iris.main,
                        boxShadow: 'none',
                    },
                    '&:active': {
                        background: paletteGreen_1.paletteGreen.iris.main,
                        boxShadow: 'none',
                    },
                    '&.Mui-disabled': {
                        border: '1px solid transparent',
                        boxShadow: '0',
                        background: paletteGreen_1.paletteGreen.dim.main,
                        color: paletteGreen_1.paletteGreen.onSurfaceColors.disabled,
                    },
                },
                text: {
                    background: '#FFFFFF',
                    border: `solid 1px transparent`,
                    '&:focus': {
                        border: `solid 1px ${paletteGreen_1.paletteGreen.iris.main}`,
                    },
                    '&:hover': {
                        background: '#FFFFFF',
                    },
                },
                outlined: {
                    backgroundColor: '#ffff',
                    border: `1px solid ${paletteGreen_1.paletteGreen.dim.main}`,
                    '&:hover': {
                        border: `1px solid ${paletteGreen_1.paletteGreen.dim.main}`,
                        background: paletteGreen_1.paletteGreen.iris_light.hover,
                    },
                    '&:focus': {
                        border: `1px solid ${paletteGreen_1.paletteGreen.iris.main}`,
                        background: paletteGreen_1.paletteGreen.iris_light.focus,
                    },
                    '&:active': {
                        border: `1px solid ${paletteGreen_1.paletteGreen.dim.main}`,
                        background: paletteGreen_1.paletteGreen.iris_light.pressed,
                    },
                    '&.Mui-disabled': {
                        border: '1px solid transparent',
                        boxShadow: '0',
                        background: paletteGreen_1.paletteGreen.dim.main,
                        color: paletteGreen_1.paletteGreen.onSurfaceColors.disabled,
                    },
                },
            },
            variants: [
                {
                    props: {
                        variant: 'containedLight',
                    },
                    style: {
                        background: paletteGreen_1.paletteGreen.iris_light.main,
                        color: paletteGreen_1.paletteGreen.iris.main,
                        border: `solid 1px transparent`,
                        '&:focus': {
                            border: `solid 1px ${paletteGreen_1.paletteGreen.iris.main}`,
                            background: paletteGreen_1.paletteGreen.iris_light.focus,
                        },
                        '&:hover': {
                            background: paletteGreen_1.paletteGreen.iris_light.hover,
                        },
                        '&:active': {
                            background: paletteGreen_1.paletteGreen.iris_light.pressed,
                        },
                        '&.Mui-disabled': {
                            border: 'none',
                            boxShadow: '0',
                            background: paletteGreen_1.paletteGreen.dim.main,
                            color: paletteGreen_1.paletteGreen.onSurfaceColors.disabled,
                        },
                    },
                },
                {
                    props: {
                        variant: 'containedDestructive',
                    },
                    style: {
                        background: paletteGreen_1.paletteGreen.destructive.main,
                        color: paletteGreen_1.paletteGreen.danger.main,
                        border: `solid 1px transparent`,
                        '&:focus': {
                            border: `solid 1px ${paletteGreen_1.paletteGreen.destructive.main}`,
                            background: paletteGreen_1.paletteGreen.destructive.focus,
                        },
                        '&:hover': {
                            border: 'none',
                            background: paletteGreen_1.paletteGreen.destructive.hover,
                        },
                        '&:active': {
                            border: 'none',
                            background: paletteGreen_1.paletteGreen.destructive.pressed,
                        },
                        '&.Mui-disabled': {
                            border: 'none',
                            boxShadow: '0',
                            background: paletteGreen_1.paletteGreen.dim.main,
                            color: paletteGreen_1.paletteGreen.onSurfaceColors.disabled,
                        },
                    },
                },
                {
                    props: {
                        variant: 'textElevated',
                    },
                    style: {
                        boxShadow: '0px 2px 2px rgba(97, 100, 117, 0.06), 0px 3px 1px rgba(97, 100, 117, 0.04), 0px 1px 5px rgba(97, 100, 117, 0.12)',
                        background: paletteGreen_1.paletteGreen.white.main,
                        color: paletteGreen_1.paletteGreen.iris.main,
                        '&:focus': {
                            border: `solid 1px ${paletteGreen_1.paletteGreen.iris.main}`,
                            background: paletteGreen_1.paletteGreen.iris_light.focus,
                        },
                        '&:hover': {
                            background: paletteGreen_1.paletteGreen.iris_light.hover,
                        },
                        '&:active': {
                            background: paletteGreen_1.paletteGreen.iris_light.pressed,
                        },
                        '&.Mui-disabled': {
                            boxShadow: '0',
                            background: paletteGreen_1.paletteGreen.dim.main,
                            color: paletteGreen_1.paletteGreen.onSurfaceColors.disabled,
                        },
                    },
                },
                {
                    props: {
                        variant: 'grey',
                    },
                    style: {
                        fontWeight: '400',
                        fontSize: '0.875rem',
                        background: paletteGreen_1.paletteGreen.grey.main,
                        color: paletteGreen_1.paletteGreen.onSurfaceColors.highEmphasis,
                        '&:focus': {
                            background: paletteGreen_1.paletteGreen.grey.main,
                        },
                        '&:hover': {
                            background: paletteGreen_1.paletteGreen.grey.main,
                        },
                        '&:active': {
                            background: paletteGreen_1.paletteGreen.grey.main,
                        },
                        '&.Mui-disabled': {
                            boxShadow: '0',
                            background: paletteGreen_1.paletteGreen.dim.main,
                            color: paletteGreen_1.paletteGreen.onSurfaceColors.disabled,
                        },
                    },
                },
            ],
        },
        MuiTextField: {
            styleOverrides: {
                root: {
                    '&.nonOutlined': {
                        '& .MuiOutlinedInput-root': {
                            background: paletteGreen_1.paletteGreen.white.main,
                            '&::placeholder': {
                                color: paletteGreen_1.paletteGreen.onSurfaceColors.disabled,
                            },
                            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                borderColor: paletteGreen_1.paletteGreen.iris.main,
                                borderWidth: '1px',
                            },
                            '&.Mui-error .MuiOutlinedInput-notchedOutline': {
                                borderColor: paletteGreen_1.paletteGreen.danger.main,
                                borderWidth: '1px',
                            },
                            '& .MuiOutlinedInput-notchedOutline': {
                                borderWidth: '1px',
                                borderColor: 'transparent',
                            },
                            '&:hover:not(&.Mui-focused)': {
                                background: paletteGreen_1.paletteGreen.iris_light.hover,
                            },
                            '&:focus:not(&.Mui-disabled)': {
                                background: paletteGreen_1.paletteGreen.iris_light.focus,
                            },
                            '&.Mui-disabled': {
                                background: paletteGreen_1.paletteGreen.dim.main,
                            },
                        },
                        '&.valid .MuiOutlinedInput-notchedOutline': {
                            borderColor: paletteGreen_1.paletteGreen.black.main,
                        },
                    },
                },
            },
        },
    },
});
exports.default = greenTheme;
